export default [
    {
        path: '/ssddt',
        component: () => import('@/views/homePage/menu/suoshuidan_dating/index.vue'),
    },
    {
        path: '/excel',
        component: () => import('@/views/homePage/menu/excel/index.vue'),
    },
    {
        path: '/suoshuiruanjian',
        component: () => import('@/views/homePage/menu/suoshuiruanjian/index.vue'),
    },
    {
        path: '/suoshuiruanjian/dealer',
        component: () => import('@/views/homePage/menu/suoshuiruanjian/dealer.vue'),
    },
    {
        path: '/ssdgw',
        component: () => import('@/views/homePage/menu/ssdgw'),
    },
    {
        path: '/sdssxb',
        component: () => import('@/views/homePage/menu/sdssxb/index.vue'),
    },
    {
        path: '/sttzzbfzx',
        component: () => import('@/views/homePage/menu/sttzzbfzx'),
    },
    {
        path: '/sttzzbfzx/zhaogu',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/zhaogu.vue'),
    },
    {
        path: '/sttzzbfzx/chaoshi',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/chaoshi.vue'),
    },
    {
        path: '/sttzzbfzx/hetong',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/hetong.vue'),
    },
    {
        path: '/sttzzbfzx/zhaogu/detail/:id',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/zhaoguDetail.vue'),
    },
    {
        path: '/sttzzbfzx/my/subscribe',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/mySubscribe.vue'),
    },
    {
        path: '/sttzzbfzx/my/offering',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/myOffering.vue'),
    },
    {
        path: '/sttzzbfzx/equity/:crowdfundingId',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/equityDetail.vue'),
    },
    {
        path: '/sttzzbfzx/contract/upload/:crowdfundingId',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/contractUpload.vue'),
    },
    {
        path: '/sttzzbfzx/market/my/purchase',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/marketMyPurchase.vue'),
    },
    {
        path: '/sttzzbfzx/market/my/offering',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/marketMyOffering.vue'),
    },
    {
        path: '/sttzzbfzx/market/my/sold',
        component: () => import('@/views/homePage/menu/sttzzbfzx/dating/marketMySold.vue'),
    },
    {
        path: '/hxwysz',
        component: () => import('@/views/homePage/menu/hxwysz/index.vue'),
    },
    {
        path: '/hxwysz/list',
        component: () => import('@/views/homePage/menu/hxwysz/list.vue'),
    },
    {
        path: '/hxwysz/detail/:id',
        component: () => import('@/views/homePage/menu/hxwysz/detail.vue'),
    },
    {
        path: '/hxwysz/result',
        component: () => import('@/views/homePage/menu/hxwysz/result.vue'),
    },
    {
        path: '/hxwysz/submit',
        component: () => import('@/views/homePage/menu/hxwysz/submit.vue'),
    },
]
